import { AutenticacionService } from './../../../services/autenticacion.service';
import { CerrarSessionModalComponent } from './../cerrar-session-modal/cerrar-session-modal.component';
import { ConstantsService } from './../../../services/constants.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TicketAyudaModalComponent } from '../ticket-ayuda-modal/ticket-ayuda-modal.component';
import { TicketImplementacionModalComponent } from '../ticket-implementaciones-modal/ticket-implementaciones-modal.component';
declare var jquery;
declare var $;

@Component({
  selector: 'app-left-sidebar',
  templateUrl: './left-sidebar.component.html',
  styleUrls: ['./left-sidebar.component.scss']
})
export class LeftSidebarComponent implements OnInit {

  @ViewChild(CerrarSessionModalComponent) public cerrarSessionModal: CerrarSessionModalComponent;
  @ViewChild(TicketAyudaModalComponent) public ticketAyudaModal: TicketAyudaModalComponent;
  @ViewChild(TicketImplementacionModalComponent) public ticketImplementacionModal: TicketImplementacionModalComponent;
  version:string;
  id:any;
  constructor(private constantsService: ConstantsService, private authService: AutenticacionService){
    this.version = "version " + constantsService.versionNumber;
  }

  ngOnInit() {
    $.App.init();
  }

  cerrarSession() {
    this.cerrarSessionModal.open();
  }

  ticketAyuda() {
    this.ticketAyudaModal.open();
  }

  ticketImplementacion() {
    this.ticketImplementacionModal.open();
  }

  hasPermission(permissionId) {
    return this.authService.hasPermission(permissionId);
  }

  hasPermissions(permissionsIds) {
    return this.authService.hasPermissions(permissionsIds);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/partials/left-sidebar/left-sidebar.component.ts